import React from "react"

import { Box } from "@theguarantors/ui-kit-v2/dist/design-system/typography"
import { HeaderV2 } from "@theguarantors/ui-kit-v2/dist/layout/HeaderV2"
import { Header } from "@theguarantors/ui-kit-v2/dist/layout/Header"
import { AddressForm } from "./components/AddressForm"
import { HowItWorks } from "./components/HowItWorks"
import { StillHaveQuestions } from "./components/StillHaveQuestions"
import { Footer } from "./components/Footer"
import { Main } from "./LandingPage.styles"
import { defaultMenuItemsV2 } from "../../constants/menu"
import { MobileDefaultHeaderCouper, DesktopDefaultHeaderCouper } from "@theguarantors/ui-kit-v2/dist/components/coupers"
import { LGLandingPageTop } from "@theguarantors/ui-kit-v2/dist/layout/HeaderV2/Headerv2.constants"
import { FeatureFlag, useFeatureFlag } from "../../hooks/use-feature-flag"
import { useRentersRedirectHelper } from "../../feature-flags/useRentersRedirectHelper"

const couper: [React.ReactNode, React.ReactNode] = [<MobileDefaultHeaderCouper />, <DesktopDefaultHeaderCouper />]

export const LandingPageComponent: React.FC = () => {
  useRentersRedirectHelper()
  const [reBrandChanges] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)
  const headerVersion: Boolean = reBrandChanges === "on"

  if (reBrandChanges === "control") {
    return null
  }

  return (
    <Box position="relative" overflow="hidden">
      {headerVersion ? (
        <HeaderV2 top={LGLandingPageTop} couper={[<></>, <></>]} menuItems={defaultMenuItemsV2} />
      ) : (
        <Header top={LGLandingPageTop} couper={couper} menuItems={defaultMenuItemsV2} />
      )}
      <Main>
        <AddressForm />
        <HowItWorks />
        <StillHaveQuestions />
      </Main>
      <Footer />
    </Box>
  )
}
